import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=4172bbd2"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050store/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4172bbd2')) {
      api.createRecord('4172bbd2', component.options)
    } else {
      api.reload('4172bbd2', component.options)
    }
    module.hot.accept("./Info.vue?vue&type=template&id=4172bbd2", function () {
      api.rerender('4172bbd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/components/Info.vue"
export default component.exports